export { IconCollection } from './IconCollection';
export { type IconCollectionProps, IconCollectionVariation, IconCollectionAlignment } from './IconCollection.types';
